/* eslint-disable */
import React, {PropTypes} from 'react';
import ConfigD from './util/ConfigD';
import { Link } from 'react-router';

const MenuDenuncia = (props) =>{
    //UPP: o item Denúncia não é apresentado no menu Registrar
    if(typeof props.canal === 'string' && props.canal.toLowerCase() === 'upp'){
        return (null);
    }
    if(!(window.location.hostname === 'www.sac.sebrae.com.br')){
        return  <li><Link to={ConfigD.getServerBase() + '/cadastrarProtocolo' + props.linkCadastrodenuncia} className="sf-with-ul"> Denúncia </Link></li>
    }else{
        return (null);

    }

}
export default MenuDenuncia;



/** WEBPACK FOOTER **
 ** ./src/components/MenuDenuncia.js
 **/